import * as types from './_actionTypes';

const initialState = {
  user: null,
  token: null,
  loading: false,
  error: null,
  isAuthenticated: false,
  redirectPath: null,
  initialCheckDone: false
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_INITIAL_CHECK_DONE:
  return {
    ...state,
    initialCheckDone: true,
     loading: false 
  };
    case types.LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case types.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload.user,
        isAuthenticated: true,
        error: null,
        initialCheckDone: true,
      };
    
    case types.LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        isAuthenticated: false,
         initialCheckDone: true,
      };
    
 case types.LOGOUT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case types.LOGOUT_SUCCESS:
      console.log('🔓 LOGOUT_SUCCESS - Clearing all auth data');
      // Keep initialCheckDone: true so AppGuard does not dispatch CHECK_AUTH
      // immediately after logout. Both cookies are gone at this point; a fresh
      // CHECK_AUTH would hit /auth/profile (401) → interceptor tries refresh →
      // refresh also 401 (no cookie) → the exact loop we are guarding against.
      // AuthGuard already redirects to /auth/login when isAuthenticated is false.
      return {
        ...initialState,
        initialCheckDone: true,
      };

    case types.LOGOUT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
        // Keep user logged in if logout fails
      };


      
    case types.REDIRECT:
      return {
        ...state,
        redirectPath: action.payload
      };
    
 case types.CHECK_AUTH_START:
      return { ...state, loading: true, error: null };

    case types.CHECK_AUTH_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
        isAuthenticated: true,
        error: null,
        initialCheckDone: true,
      };

    case types.CHECK_AUTH_FAILURE:
      return {
        ...state,
        loading: false,
        user: null,
        isAuthenticated: false,
        error: action.payload,
        initialCheckDone: true,
      };

    default:
      return state;
  }

};

export default authReducer;